export default __webpack_public_path__ + "static/media/news3.3a4dfb45.jpg";